import './index.scss'

class Contact {
    constructor(el) {
        this.$el = el
    }
    init() {

    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.oce-contact') ].forEach($block => {
        $block.expandygg = new Contact($block)
    })
}, {capture: false, passive: true, once: true} || false)
